<template>
    <b-overlay :show="tableLoading" rounded="sm">
        <b-card class="inner-block progress-status">
            <b-card-header>
                <b-row class="mt-2">
                    <b-col cols="12" class="d-flex">
                        <b-input id="search-input" type="text" :placeholder="$translate('search')" v-model="query"></b-input>
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body>
                <b-col class="page-block">
                    <strong>
                        {{ $translate("page") }}: {{ pagination.page }}
                        {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                        {{ pagination.total }}
                    </strong>
                </b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <div class="responsive-table">
                        <b-table class="table table-striped" :fields="fields" :items="items" :per-page="itemsPerPage"
                            :current-page="currentPage" :filter="filters" show-empty>
                            <template #cell(id)="{ item }">
                                <b-button :id="'view-bill-payment-to-btn-'+item.id" class="test-view-bill-payment-to-btn" v-if="hasPermissionView" @click="$emit('show-item', item.id)"
                                    variant="pink-button">
                                    <img src="@/assets/images/icon/view.svg" />
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-card-body>
            <b-row>
                <b-col>
                    <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                        :total-rows="pagination.total" :per-page="pagination.pageSize" aria-controls="customerTable"
                        :prev-text="$translate('previous')" :next-text="$translate('next')" pills
                        align="center"></b-pagination>

                </b-col>
            </b-row>
        </b-card>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'BillPaymentTo-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: {
        //type, // not used
        /**
         * The title of the table
         */
        title: String,
    },
    components: {},

    data() {
        return {
            filters: {
            },
            query: '',
            itemsPerPage: 15,
            tableLoading: false,
            currentPage: 1,
            rowsLength: this.rows,
        }
    },

    mounted() {
        this.doSearch(true)
    },


    watch: {},

    computed: {
        fields() {
            return [
                { key: 'id', label: this.$translate('actions') },
                { key: 'username', label: this.$translate('username') },
                { key: 'host', label: this.$translate('host') },
                { key: 'encryption', label: this.$translate('encryption') },
                { key: 'port', label: this.$translate('port') },
                { key: 'protocol', label: this.$translate('protocol') },
                { 
                    key: 'validate_cert', 
                    label: this.$translate('validate_cert'), 
                    formatter: (value) => value ? 'Yes' : 'No'
                },
            ]
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.billPaymentTo.pagination || { page: 1 };
        },
        items() {
            const items =
                this.$store.state.billPaymentTo.items

                || []
            return items
        },
        user() {
            return this.$store.state.user
        },

        rows() {
            return this.items.length
        }
    },

    methods: {
        async doSearch(isforcedReload = false) {
            try {

                let {
                    query,
                    pagination: { page },
                    filters
                } = this

                if (query != "" && query.length < 3) return;

                page = parseInt(page) || 1;

                this.tableLoading = true

                await this.$store.dispatch('billPaymentTo/fetchAll', {
                    query,
                    filters,
                    page,
                    isforcedReload
                })
            } catch (err) {
                console.log('billPaymentTo fetch Error: ', err);
                this.doToast(this.$translate('error'), err.message, 'danger')
            } finally {
                this.tableLoading = false
            }
        },
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Type?'
            const message = `${this.$translate('delete_note')} ${item.email}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('billPaymentTo/delete', id)
                        .then(() => {
                            this.doToast(
                                this.$translate('deleted'),
                                this.$translate('item_delete_alert'),
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                }
            })
        },
    },
}
</script>
<style></style>
